import React from "react";
import "./Headr.css";
//import Lnkd from "./Assets/lncin.svg";
import logo from "./Assets/lnk.svg";

function Headr() {
  return (
    <div className="hdr0">
      <div className="hdr1">
        <p className="pCon">Contact us</p>
        <a href="mailto:S.K.Air@outlook.com">
          <p className="pEmail">S.K.Air@outlook.com</p>
        </a>
      </div>
      <a href="https://linkedin.com/company/sk-air/">
        <img src={logo} className="lnkd" alt="logo" />
      </a>
    </div>
  );
}

export default Headr;
